export const PERSON_ID = "personId";
export const COMPANY_ID = "companyId";
export const SUBLIME_EMPLOYEE_ID = "sublimeEmployeeId";
export const WORKSPACE_TYPE = "wsType";
export const WORKSPACE_ID = "wsId";
export const CHANGE_WORKSPACE_TYPE = "chWsType"; // is needed to avoid using these params in other components. Only for changing workspace
export const CHANGE_WORKSPACE_ID = "chWsId";
export const WORKFLOW_ID = "workflowId"
export const CONTRACTOR_TYPE = "contractorType";